export default __webpack_public_path__ + "static/media/825.698606df.gif";